export default __webpack_public_path__ + "static/v4-978b696d1691973aa6a6d2a1bd3f3d3c.png";